<template>
    <footer class="footer"> 

        <div class="row">
          <div class="text-center text-muted mt-4">
            <!-- <a href="/termsofuse">Όροι Χρήσης</a> |  -->
            <a href="/privacy-policy">Πολιτική Προστασίας Προσωπικών Δεδομένων</a>
          </div>          
        </div>

        <espa-widget />

       <div class="row">
         <div class="text-center clearfix">© Copyright 2023 Ε.Ε.Τ.Α.Α.</div>

          <div class="row top-logos">
            <!-- <div class="col-xs-6"> <img class="logo enarmonisis" src="@/assets/enarmonisis-logo.svg" /></div> -->
            <div class="col-xs-12" style="text-align:center"><img class="eetaa-logo" src="@/assets/eeta-logo.svg" /></div>
          </div>
         
          <div class="intelli-dev">
            <p>
              Design and Development by:
              <a href="http://www.intellisoft.gr/" target="_blank">
                <img alt="IntelliSoft" src="@/assets/intellisoft-logo-24x13.png" width="24" height="13" />
                <span class="inw">INTELLI</span><span class="inb">SOFT</span>
              </a>
            </p>
          </div>
       </div>

    </footer>
</template>

<script>

import EspaWidget from "../shared/espaWidget.vue";

export default {
  components:{
    "espa-widget":EspaWidget
  },
  data(){
    return {currentTime:''}
  },
  computed:{
    isAuthenticated(){
      return  this.$store.getters.isAuthenticated;
    },
  },
  created(){
    setInterval(()=>{
                    this.currentTime = this.$moment().format("HH:mm:ss");}
      ,1000);
  }
}
</script>

<style lang="scss" scoped>
.clearfix{
  clear: both;
}
footer{
  background: rgba(255, 255, 255, 0);
}
.eetaa-logo{
  max-width: 200px;
}
.intelli-dev{
    width: auto;
    text-align: center;
    color: black;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 13px;
    padding: 10px 0;
    margin: 0 auto;
    bottom: 20px;

    img{
        margin-right: 3px;
        margin-bottom: -2px;
    }
    a {
        font-size: 13px;
       color: #000;
       text-decoration: none;
    }

    .inb {
        font-weight: 800;
    }
}

</style>


